<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";

  export let iconType: string;
  export let badgeText: string;
  export let testIdSuffix: string;
  export let boldText: boolean = false;
  export let surfaceClass: string = "fizz-surface";
  export let iconFill: string = "#848484"; // gray-500
  export let removePadding: boolean = true;
  export let subdued: boolean = true;
  export let textColor: string = "";
</script>

<style>
  .wrap-text {
    white-space: normal;
    align-items: start;
  }
</style>

<div
  class="{textColor} fizz-flex-row-4 fizz-badge wrap-text {surfaceClass}"
  class:fizz-inset-none={removePadding}
  data-testid="product-card-badge-{testIdSuffix}"
>
  <div style="padding-top: 0.1rem">
    <Icon type={iconType} height="14" width="14" fill={iconFill} />
  </div>
  <span
    class:fizz-text-subdued={subdued}
    class="fizz-text-small"
    style={boldText ? "" : "font-weight: normal;"}
  >
    {badgeText}
  </span>
</div>
